import defineCustomElement from '../define-custom-element.js';
import TpSportIcon from './tp-sport-icon.js';

defineCustomElement('tp-sport-icon', TpSportIcon);

export {
  TpSportIcon
}
